module.exports = __webpack_public_path__ + "static/media/login_mes.3f4161a4.png";